// Mobile Menu JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Initialize menu functionality
  initializeMenu();
  
  // Initialize search functionality
  initializeSearch();
});

function initializeMenu() {
  const submenus = document.querySelectorAll('.mobile-nav__submenu');
  const menuLinks = document.querySelectorAll('.mobile-nav__parent-link[data-menu-id]');
  
  // Hide all submenus initially
  submenus.forEach(menu => {
    menu.style.display = 'none';
  });
  
  // Show first submenu by default (only if it exists)
  const firstSubmenu = document.querySelector('.mobile-nav__submenu');
  if (firstSubmenu) {
    firstSubmenu.style.display = 'block';
    
    // Activate first menu item with a submenu
    const firstMenuItem = document.querySelector('.mobile-nav__parent-link[data-menu-id]');
    if (firstMenuItem) {
      firstMenuItem.classList.add('mobile-nav__parent-link--active');
    }
  }
  
  // Add click event listeners to menu items
  menuLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const menuId = this.getAttribute('data-menu-id');
      showMenu(menuId, this);
    });
  });
}

function showMenu(menuId, clickedElement) {
  // Hide all submenus
  const submenus = document.querySelectorAll('.mobile-nav__submenu');
  submenus.forEach(menu => {
    menu.style.display = 'none';
  });
  
  // Show the selected submenu
  const targetMenu = document.getElementById(menuId);
  if (targetMenu) {
    targetMenu.style.display = 'block';
  }
  
  // Set active class on clicked menu item
  const menuLinks = document.querySelectorAll('.mobile-nav__parent-link');
  menuLinks.forEach(link => {
    link.classList.remove('mobile-nav__parent-link--active');
  });
  
  if (clickedElement) {
    clickedElement.classList.add('mobile-nav__parent-link--active');
  }
}

function initializeSearch() {
  const typewriterPlaceholder = document.getElementById('typewriter-placeholder');
  const searchInput = document.getElementById('mobile-product-search');
  const searchClearBtn = document.querySelector('.mobile-nav__search-clear');
  const searchResults = document.querySelector('.mobile-nav__search-results');
  
  // Array of rotating placeholder texts
  const placeholderTexts = [
    "Search for Moisturizers",
    "Search for Serums",
    "Search for Sunscreens",
    "Search for Face Washes"
  ];
  
  let currentTextIndex = 0;
  let typewriterIndex = 0;
  let isDeleting = false;
  let typingSpeed = 100; // Faster typing speed (was 150)
  let pauseTime = 1500; // Shorter pause time (was 2000)
  let typewriterTimeout;
  
  function typeWriter() {
    // Stop the animation if someone is typing
    if (searchInput && searchInput.value.length > 0) {
      typewriterPlaceholder.textContent = '';
      return;
    }
    
    // Get the current text to type/delete
    const currentText = placeholderTexts[currentTextIndex];
    
    if (!isDeleting && typewriterIndex === currentText.length) {
      // Text fully typed, pause then delete
      isDeleting = true;
      typingSpeed = 50; // Faster when deleting (was 80)
      typewriterTimeout = setTimeout(typeWriter, pauseTime);
      return;
    } else if (isDeleting && typewriterIndex === 0) {
      // Text fully deleted, move to next text
      isDeleting = false;
      currentTextIndex = (currentTextIndex + 1) % placeholderTexts.length;
      typingSpeed = 100; // Normal speed when typing
      typewriterTimeout = setTimeout(typeWriter, 300); // Shorter pause between texts
      return;
    }
    
    // Either add or remove a character
    if (isDeleting) {
      typewriterIndex--;
    } else {
      typewriterIndex++;
    }
    
    // Update the text
    typewriterPlaceholder.textContent = placeholderTexts[currentTextIndex].substring(0, typewriterIndex);
    
    // Randomize typing speed slightly for more natural effect (but keep it faster overall)
    const randomSpeed = Math.random() * 30 + typingSpeed; // Less randomness for more consistent speed
    typewriterTimeout = setTimeout(typeWriter, randomSpeed);
  }
  
  // Start the typewriter effect
  typeWriter();
  
  // AJAX Search functionality
  if (searchInput) {
    let debounceTimer;
    
    // Focus event - clear placeholder
    searchInput.addEventListener('focus', function() {
      clearTimeout(typewriterTimeout);
      typewriterPlaceholder.textContent = '';
    });
    
    // Blur event - restart typewriter if empty
    searchInput.addEventListener('blur', function() {
      if (this.value.trim().length === 0) {
        typewriterIndex = 0;
        isDeleting = false;
        typeWriter();
      }
    });
    
    // Input event handler
    searchInput.addEventListener('input', function() {
      const query = this.value.trim();
      
      // Stop typewriter animation when typing
      clearTimeout(typewriterTimeout);
      typewriterPlaceholder.textContent = '';
      
      // Show/hide clear button based on if there's text
      if (query.length > 0) {
        searchClearBtn.style.display = 'block';
      } else {
        searchClearBtn.style.display = 'none';
        searchResults.style.display = 'none';
        
        // Restart typewriter if empty
        typewriterIndex = 0;
        isDeleting = false;
        typeWriter();
      }
      
      // Debounce the search request
      clearTimeout(debounceTimer);
      if (query.length >= 2) {
        debounceTimer = setTimeout(function() {
          performSearch(query);
        }, 300);
      }
    });
    
    // Clear button event handler
    if (searchClearBtn) {
      searchClearBtn.addEventListener('click', function() {
        searchInput.value = '';
        searchClearBtn.style.display = 'none';
        searchResults.style.display = 'none';
        
        // Restart typewriter
        typewriterIndex = 0;
        isDeleting = false;
        typeWriter();
      });
    }
    
    // Click outside to close results
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.mobile-nav__search')) {
        searchResults.style.display = 'none';
      }
    });
  }
  
  // AJAX search function
  function performSearch(query) {
    // Show loading indicator
    searchResults.innerHTML = '<div class="mobile-nav__search-no-results">Searching products...</div>';
    searchResults.style.display = 'block';
    
    // Build the search URL - searching only products
    const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`;
    
    fetch(searchUrl)
      .then(response => response.json())
      .then(data => {
        const products = data.resources.results.products;
        
        if (products && products.length > 0) {
          // Build results HTML
          let resultsHtml = '';
          
          products.forEach(product => {
            resultsHtml += `
              <a href="${product.url}" class="mobile-nav__search-result-item">
                <img src="${product.image || '/assets/no-image.jpg'}" alt="${product.title}" class="mobile-nav__search-result-image">
                <div class="mobile-nav__search-result-info">
                  <div class="mobile-nav__search-result-title">${product.title}</div>
                  <div class="mobile-nav__search-result-price">${product.price}</div>
                </div>
              </a>
            `;
          });
          
          // Add view all link
          resultsHtml += `
            <a href="/search?q=${encodeURIComponent(query)}&type=product" class="mobile-nav__search-result-item mobile-nav__search-view-all">
              <span>View all results</span>
            </a>
          `;
          
          searchResults.innerHTML = resultsHtml;
        } else {
          // No results found
          searchResults.innerHTML = '<div class="mobile-nav__search-no-results">No products found. Try a different search.</div>';
        }
      })
      .catch(error => {
        console.error('Search error:', error);
        searchResults.innerHTML = '<div class="mobile-nav__search-no-results">An error occurred. Please try again.</div>';
      });
  }
}